import React from "react";



export default function ActiveStudents() {
    return (
        <div>
            <h4><b>Present Students</b></h4>
        </div>
    )
}
